import PlateMaterialOptions from './PlateMaterialOptions';

const units = ["M","cells"];
const arrowsMap = { up:"▲", down:"▼", right:"►", left:"◄" }

export default function DilutionTable({set,state,ops}){


  let opSel = (<select value={state.op} onChange={e => set({op:e.target.value})}>
    {Object.keys(ops).map(opt => <option value={opt}>{opt}</option>)}
  </select>);

  let factorUnitsSel = (<select style={{fontSize:10,width:50}} value={state.factorUnits} onChange={e => set({
    factorUnits:e.target.value,
  })}>
    {units.map(opt => <option value={opt}>{opt}</option>)}
  </select>);






  const arrowMargin = -10;
  const arrowStyle = { margin:arrowMargin }

  const arrows = ["up","down","left","right"];

  const data = state.data;


  let arrowsDiv = (
    <div class="sg-row">
      {arrows.map(dir => <div onClick={() => set({direction:dir})} style={{lineHeight:1, fontSize:16, borderRadius:5,}} class={`tiny-padding ${dir===state.direction?"selected":"dark-hoverable"}`}>{arrowsMap[dir]}</div>)}
    </div>
  )

  const layoutForm = (
    <div style={{border:'1px solid #ccc',padding:10,borderRadius:5,marginTop:20}}>


      <div class="sg-row">
        № conditions: 
        <div class="flex-expand"/>
        <input class="no-spinner" style={{width:30,fontSize:10}} type={"number"} value={state.length} onChange={e => set({length:Number(e.target.value)})}/>
      </div>

      <div style={{height:20}} class="sg-row v-center">
        Control:
        <div class="flex-expand"/>
        <input type="checkbox" checked={state.control} onChange={e => set({control:e.target.checked})}/>
      </div>

      <div class="sg-row">
        Initial:
        <div class="flex-expand"/>
        <input style={{width:50,fontSize:10}} type="number" value={state.initialValue} onChange={e => set({initialValue:Number(e.target.value)})}/>
      </div>


      <div class="sg-row">Operation:<div class="flex-expand"/> {opSel}</div>


      <div class="sg-row">
        Factor: 
        <div class="flex-expand"/>
        <div class="sg-row">
          <input type={"number"}  style={{width:40, fontSize:10}} value={state.factor} min={0} onChange={e => set({factor:Number(e.target.value)})}/>
        </div>
      </div>
      {false && (<div class="sg-row">
        Units:
        <div class="flex-expand"/>
        {factorUnitsSel}
      </div>)}


      <div class="sg-row">
        Replicates:
        <div class="flex-expand"/>
        <input min={1} increment={1} style={{width:30,fontSize:10}} type="number" value={state.replicates} onChange={e => set({replicates:Number(e.target.value)})}/>
      </div>


      <div style={{textAlign:'center',marginTop:20}}>
      {arrowsDiv}
      </div>

    </div>
  )

  return (
    <div id="dilution-table">

      <PlateMaterialOptions state={state} set={set}/>

      {layoutForm}

    </div>
  )







}
